<template>
  <div class="zj-moble-app-page event-report">
    <div class="position_header">
      <div class="header_info">我的位置：{{ Location }}</div>
      <div class="header_info_r" @click="getlocationpoint">
        <img
          slot="icon"
          src="../images/icon_shangbaoweizhi.png"
          :style="{ height: '0.28rem', width: '0.28rem' }"
        />
        <span>上报位置</span>
      </div>
      <div class="container">
        <div id="allmap" class="map"></div>
        <p class="errortext" ref="errtext"></p>
      </div>
    </div>
    <!--  <mt-header class="zj-mt-header white" fixed="true" :title="Location" slot="left">
      <mt-button slot="left" icon="back" @click.native="GotoBack" class="nav-btn black">我的位置：</mt-button>
      <mt-button slot="right" icon="more" class="nav-btn blue" size="small">
        <img
          slot="icon"
          src="../images/icon_shangbaoweizhi.png"
          :style="{ height:'2.5rem',width:'2.5rem'}"
        />
        上报位置
      </mt-button>
    </mt-header> -->
    <div class="zj-mt-content padding">
      <!-- 顶部tab切换 -->
      <div
        style="display: flex; justify-content: flex-start; align-items: center"
      >
        <div class="leftBtn" @click="tabSwitch('first')">
          <div class="btnFont activeTab">待执行任务</div>
          <div class="btnStyle" v-show="activeTabDom === 'first'"></div>
          <div class="btnStyle2" v-show="activeTabDom === 'second'"></div>
        </div>
        <div
          class="rightBtn"
          @click="tabSwitch('second')"
          style="margin-left: 0.3rem"
        >
          <div class="btnFont">事件反馈</div>
          <div class="btnStyle" v-show="activeTabDom === 'second'"></div>
          <div class="btnStyle2" v-show="activeTabDom === 'first'"></div>
        </div>
      </div>
      <mt-tab-container v-model="activeTabDom" swipeable>
        <mt-tab-container-item id="first">
          <div style="margin-top: 200px" v-if="taskArr.length == 0">
            <img
              style="margin: 0 auto; display: block"
              src="../images/zanwurenwu.png"
            />
            <p class="spaceTxt">当前暂无待执行任务</p>
          </div>
          <div v-if="taskArr.length > 0">
            <div class="listOutline" v-for="item in taskArr" :key="item.Id">
              <!-- 状态图标 -->
              <!-- v-if="noComTask.length>0" -->
              <div class="statusIcon statusNozhi"></div>
              <div class="topBox">
                <ul>
                  <li class="topLi">{{ item.TaskTiltle }}</li>
                  <li class="dateLi">
                    发布于：{{ formatDate(item.CreateTime) }}
                  </li>
                </ul>
                <div class="lineBlue"></div>
              </div>
              <div class="middleInfo">
                {{ item.TaskDesc == "" ? "任务详情暂无" : item.TaskDesc }}
              </div>
              <ul class="btmInfo">
                <li class="">
                  对接人：{{
                    item.ChargerName == "" ? "暂无信息" : item.ChargerName
                  }}
                </li>
                <li class="">{{ item.Phone }}</li>
              </ul>
              <!-- <div class="feedbackBtn"></div> -->
            </div>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item class="event-report" id="second">
          <div>
            <mt-field
              label="反馈内容"
              v-model="memo"
              placeholder="请填写您要反馈的内容"
              type="textarea"
              rows="4"
            ></mt-field>
          </div>
          <div class="media-section">
            <div class="section-title">图片</div>
            <nutimagepicker
              :imgList.sync="imgList"
              delMode="longtap"
              longTapTime="1000"
            ></nutimagepicker>
          </div>
          <div class="media-section">
            <div class="section-title">短视频</div>
            <nutvideopicker
              :imgList.sync="videoList"
              accept="video/*"
              delMode="longtap"
              longTapTime="1000"
            ></nutvideopicker>
          </div>
          <!-- <div class="media-section">
            <div class="section-title">语音</div>
            <nutimagepicker
              :imgList.sync="audioList"
              accept="audio/*"
              delMode="longtap"
              longTapTime="1000"
            ></nutimagepicker>
          </div>-->
          <!-- 事态反馈提交按钮 -->
          <div class="zj-mt-footer">
            <mt-button
              type="danger"
              :attr="{ maxlength: 10 }"
              @click.native="submit"
              size="middle"
              ><span style="font-size: 0.3rem">提交</span></mt-button
            >
          </div>
        </mt-tab-container-item>
      </mt-tab-container>
    </div>

    <remote-script
      src="//api.map.baidu.com/api?v=3.0&ak=ERZS9uzwv1zEBuSEAxN5DM5qjZBVHIfq"
    ></remote-script>
    <remote-script
      src="http://developer.baidu.com/map/jsdemo/demo/convertor.js"
    ></remote-script>
  </div>
</template>
<script>
import ZJApp from "../../../app";
import MyApis from "../../../../../plugins/emergency/src/apis";

import "./component/importjs";
import nutimagepicker from "../../../components/imagepicker/imagepicker.vue";
import "../../../components/imagepicker/imagepicker.scss";
import nutvideopicker from "../../../components/imagepicker/videopicker.vue";
import "../../../components/imagepicker/videopicker.scss";

// eslint-disable-next-line no-unused-vars
import { Field, Cell, Toast, Indicator } from "mint-ui";
import waitAll from "../../../../../utils/src/waitAll";

export default {
  name: "EventsReport",
  controller: "UI",
  action: "EventsReport",
  components: {
    nutimagepicker,
    nutvideopicker,
  },
  props: {
    query: {
      //任务执行id
      ExecutTaskId: {
        type: String,
        require: true,
        default: "",
      },
      ExecutId: {
        type: String,
        require: true,
        default: "",
      },
      from: {
        type: String,
        require: false,
        default: "",
      },
    },
  },
  data() {
    return {
      Location: "新疆天山天池",
      memo: "",
      // Feedback: {
      //   memo: ""
      // },
      activeTabDom: "first",
      imgList: [],
      videoList: [],
      audioList: [],
      msgkey: {
        emergencyFeedbackKey: "MessageKey_EmergencyFeedBack",
      },
      Task: this.$props.query.Task ? JSON.parse(this.$props.query.Task) : {},
      tast: "",
      noComTask: [],
      latitude: "",
      longitude: "",
      options: {
        enableHighAccuracy: true, // --->是否获取更精确的位置  true/false
        timeout: 5000, // --->请求超时时间,单位ms；
        maximumAge: 0,
      },
      taskArr: [],
    };
  },
  created() {
    let type = this.$route.query.type;
    if (type) {
      this.activeTabDom = type;
    }
    this.getlocationpoint();
    this.getTask();
    // 百度地图API功能
    // this.$nextTick(() => {
    //   this.getLocation();
    //   let watch1 = window.navigator.geolocation.watchPosition(this.getLocation); // watchPosition()方法：不停的获取和更新用户的地理位置信息，执行间隔时间0ms；当设备地理位置发生改变时，自动调用；  好像删除也么有影响
    //   console.log(watch1);
    //   //清除watch1
    //   window.navigator.geolocation.clearWatch(watch1);
    // });
  },
  methods: {
    GotoBack() {
      this.$router.back(-1);
    },

    getlocationpoint() {
      // let isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      // if (isIOS){
      //   var geolocation = new BMap.Geolocation();
      //   geolocation.enableSDKLocation();
      //   geolocation.getCurrentPosition(function (r) {
      //     if (this.getStatus() == BMAP_STATUS_SUCCESS) {
      //       let site = 
      //         r.address.province + 
      //         r.address.city + 
      //         r.address.district + 
      //         r.address.street;
      //       this.Location = site;
      //     } else{
      //       alert("获取地理位置失败");
      //     }
      //   })
      // }
      this.Location = "定位中...";
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.showPosition,
          this.showError
        );
      } else {
        alert("该浏览器不支持地理位置!");
        this.Location = "新疆天山天池";
      }
    },
    showPosition(position) {
      const that = this;
      //GPS经纬度
      let x = position.coords.latitude;
      let y = position.coords.longitude;
      // eslint-disable-next-line no-undef
      var gpsPoint = new BMap.Point(y, x);
      setTimeout(function () {
        // eslint-disable-next-line no-undef
        // BMap.Convertor.translate(gpsPoint, 0, this.translateCallback(res));
        // eslint-disable-next-line no-undef
        BMap.Convertor.translate(gpsPoint, 0, function (resPoint) {
          if (resPoint) {
            y = resPoint.lng;
            x = resPoint.lat;
          }

          that.latitude = x;
          that.longitude = y;
          // eslint-disable-next-line no-undef
          const point = new BMap.Point(y, x);
          // eslint-disable-next-line no-undef
          const geo = new BMap.Geocoder(); // --> 创建BMap.Geocoder 实例
          let pt = point;

          geo.getLocation(pt, function (rs) {
            /** addressComponents对象可以获取到详细的地址信息 */
            let addComp = rs.addressComponents;
            console.log(addComp);
            let site =
              addComp.province +
              addComp.city +
              addComp.district +
              addComp.street +
              addComp.streetNumber;

            that.Location = site;
          });
        });
      }, 1000);
    },

    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          alert("用户拒绝对获取地理位置的请求。");
          break;
        case error.POSITION_UNAVAILABLE:
          alert("位置信息是不可用的。");
          break;
        case error.TIMEOUT:
          alert("请求用户地理位置超时。");
          break;
        case error.UNKNOWN_ERROR:
          alert("未知错误。");
          break;
      }
      this.Location = "新疆天山天池";
    },
    getTask() {
      let ExecutTaskSearch = {};
      if (this.query.from === "video") {
        ExecutTaskSearch = {
          ExecutId: this.query.ExecutId,
          TaskStatus: "1",
          Validity: 1,
        };
      } else {
        ExecutTaskSearch = {
          ExecutTaskId: this.query.ExecutTaskId,
          TaskStatus: "1",
          Validity: 1,
        };
      }

      // let that = this;
      return new MyApis.ExecutTaskApi()
        .FindByConditions(ExecutTaskSearch)
        .then((res) => {
          if (res.RspCode == "1" && res.data.Data != null) {
            var result = res.data.Data;
            // eslint-disable-next-line no-undef
            this.taskArr = result || [];
            if (result.length > 0) {
              this.Task = result[0];
            }

            console.log("task", result);
          }
        })
        .catch((e) => {
          //Toast(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          console.log(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    choseimg() {},
    tabSwitch(tab) {
      console.log(tab);
      this.activeTabDom = tab;
    },
    submit: function () {
      let that = this;

      if (!that.memo) {
        Toast({ message: "请填写你要反馈的内容" });
        return false;
      }

      that.submitFeedback();
    },
    submitFeedback() {
      let that = this;
      let uuid = ZJApp.ZJUtils.uuid();

      Indicator.open({
        text: "反馈上传中...",
        spinnerType: "triple-bounce",
      });

      //插入反馈数据
      new MyApis.ExecutFeedbackApi()
        .AddItem(that.newfeedback(uuid))
        .then((r) => {
          let data = r.data.Data;
          if (data) {
            that
              .uploadAttch(uuid)
              .then((r) => {
                if (r && r.length > 0) {
                  that
                    .submitFeedBackAttachment(uuid, r)
                    // eslint-disable-next-line no-unused-vars
                    .then((r) => {
                      //增加反馈成功，发送反馈成功消息
                      that.$notify.broadcase({
                        key:
                          that.msgkey.emergencyFeedbackKey + that.Task.ExecutId,
                        data: that.feedback,
                      });

                      Indicator.close();
                      Toast({ message: "事态反馈成功" });
                    })
                    .catch((e) => {
                      console.error(e);
                      Indicator.close();
                      Toast({
                        message: e.RspMsg
                          ? e.RspMsg
                          : "事态反馈成功，上传附件失败！",
                      });
                    });
                } else {
                  //增加反馈成功，发送反馈成功消息
                  that.$notify.broadcase({
                    key: that.msgkey.emergencyFeedbackKey + that.Task.ExecutId,
                    data: that.feedback,
                  });

                  Indicator.close();
                  Toast({ message: "事态反馈成功" });
                }
              })
              // eslint-disable-next-line no-unused-vars
              .catch((e) => {
                console.log(e);
                Indicator.close();
                Toast({ message: "事态反馈成功，上传附件失败！" });
              });
          } else {
            Indicator.close();
            Toast({ message: r.RspMsg ? r.RspMsg : "事态反馈失败！" });
          }
        })
        .catch((e) => {
          console.error(e);
          Indicator.close();
          Toast({ message: e.RspMsg ? e.RspMsg : "事态反馈失败！" });
        });
    },
    //插入附件
    uploadAttch(feedid) {
      return new Promise((resolve, reject) => {
        let mediaList = [].concat(this.imgList, this.videoList, this.audioList);
        var arr = [];
        mediaList.forEach((item) => {
          var option = {
            file: item.file,
            data: {
              module: "emergency", //模块名
              submodule: "H5", //子模块
              assocID: feedid, //业务ID
              uploader: "H5", //上传人
            },
            onProgress: () => {},
            onSuccess: () => {},
            onError: () => {},
          };
          arr.push(this.httpRequest(option));
        });

        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    //插入反馈附件
    submitFeedBackAttachment(feedid, rArr) {
      let deptId = this.Task.OrgId;
      let user = this.Task.ChargerName;

      var arr = [];
      rArr.forEach((r) => {
        arr.push(
          new MyApis.FeedAttachApi().AddItem({
            Creater: user,
            Modifier: user,
            CreateTime: new Date(),
            ModifyTime: new Date(),
            Validity: 1,
            OrgId: deptId,
            AttachId: ZJApp.ZJUtils.uuid(),
            FeedBackId: feedid,
            FileName: r.FileName,
            FileActName: r.FileName,
            FileUrl: r.DownloadPath,
            FileType: r.Extension,
            UploadDate: new Date(),
            FileId: r.FileID,
            PhysicalPath: r.Path,
          })
        );
      });

      return new Promise((resolve, reject) => {
        waitAll(arr)
          .then((r) => {
            resolve(r);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    newfeedback: function (uuid) {
      let deptId = this.Task.OrgId;
      let user = this.Task.ChargerName;
      var feedback = {
        Creater: user,
        Modifier: user,
        CreateTime: new Date(),
        ModifyTime: new Date(),
        Validity: 1,
        OrgId: deptId,
        FeedbackId: uuid,
        ExecutId: this.Task.ExecutId,
        //ExecutTaskId: this.Task.ExecutTaskId,
        //TaskTiltle: this.Task.TaskTiltle,
        //TaskDesc: this.Task.TaskDesc,
        FeedType: "2", //反馈类型(1-事件反馈2-事态上报)
        //Charger: this.Task.ChargerName,
        //TelPhone: this.Task.Phone,
        FeedbackDesc: this.memo,
      };
      return feedback;
    },
    formatDate(value) {
      // 获取单元格数据
      let data = value;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  computed: {
    httpRequest() {
      return ZJApp.ZJApis.ZJUploader.upload;
    },
  },
};
</script>
<style type="text/css" scoped>
.add-image {
  width: 50px;
  height: 50px;
  background-image: url(/images/addImg.png);
  background-size: 100%;
}
.position_header {
  width: 100%;
  height: 0.75rem;
  background: #fff;
  color: #333;
  padding: 0 0.3rem;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header_info {
  font-size: 0.28rem;
  text-align: left;
  flex: 1;
}
.header_info_r {
  width: 1.5rem;
  height: 100%;
  line-height: 0.75rem;
  font-size: 0.28rem;
  color: #2c91eb;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: 0.2rem;
}
.btnStyle {
  width: 0.61rem;
  height: 4px;
  background-color: #2c91eb;
  border-radius: 30px;
  margin: 0.12rem auto 0;
}
.btnStyle2 {
  width: 0.61rem;
  height: 4px;
  background-color: transparent;
  margin: 0.12rem auto 0;
}
.btnFont {
  color: #3d4146;
  font-size: 0.3rem;
}
.activeTab {
  font-size: 0.34rem;
  font-weight: bold;
}
.spaceTxt {
  color: #3c3c3c;
  font-size: 0.34rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.4rem;
}
.listOutline {
  /*width: 6.9rem;*/
  width: 100%;
  height: 3.8rem;
  background-color: #fff;
  position: relative;
}
.statusIcon {
  position: absolute;
  right: 0;
  top: 0;
  width: 1.43rem;
  height: 1.46rem;
}
.statusNozhi {
  background: url("../images/1_daizhixing.png") no-repeat;
  background-size: cover;
}
.topBox {
  position: relative;
  padding-top: 0.3rem;
  padding-left: 0.5rem;
}
.topLi {
  font-size: 0.32rem;
  font-weight: bold;
  color: #3d4146;
  list-style: none;
}
.dateLi {
  font-size: 0.28rem;
  color: #333;
  line-height: 0.5rem;
  list-style: none;
}
.lineBlue {
  position: absolute;
  width: 0.06rem;
  height: 0.74rem;
  background-color: #2c91eb;
  left: 0.3rem;
  top: 0.36rem;
}
.middleInfo {
  width: 4.76rem;
  margin-left: 0.3rem;
  margin-top: 0.15rem;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /**显示的行数**/
  overflow: hidden; /**隐藏超出的内容**/
  font-size: 0.28rem;
  color: #999;
}
.btmInfo {
  position: absolute;
  left: 0.3rem;
  bottom: 0.3rem;
}
.btmInfo li {
  font-size: 0.28rem;
  color: #999999;
  line-height: 0.46rem;
  list-style: none;
}
.feedbackBtn {
  width: 2.76rem;
  height: 1.46rem;
  background: url("../images/feedback.png") no-repeat;
  position: absolute;
  right: 0rem;
  bottom: 0rem;
}
</style>